import Cookies from 'js-cookie';
export { default as Cookies } from 'js-cookie';
export var setCookie = function (name, cookie) {
    if (typeof cookie === 'string')
        cookie = {
            token: cookie
        };
    if (!cookie.token) {
        return Cookies.remove(name, cookie.token);
    }
    return Cookies.set(name, cookie.token, {
        expires: cookie.expires_at && new Date(cookie.expires_at)
    });
};
export var getAdminAccessToken = function () {
    return Cookies.get("accessToken");
};
export var getAdminRefreshToken = function () {
    return Cookies.get("refreshToken");
};
export var getAccessToken = function (integrationName) {
    return Cookies.get(integrationName + "-bee-access-token");
};
export var setAccessToken = function (integrationName, cookie) {
    setCookie(integrationName + "-bee-access-token", cookie);
};
export var getRefreshToken = function (integrationName) {
    return Cookies.get(integrationName + "-bee-refresh-token");
};
export var setRefreshToken = function (integrationName, cookie) {
    setCookie(integrationName + "-bee-refresh-token", cookie);
};
export var logout = function (integrationName) {
    Cookies.remove(integrationName + "-bee-access-token");
    Cookies.remove(integrationName + "-bee-refresh-token");
};
